import React, { Fragment } from "react";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";
const SeoDetailPage = () => {

  return (
    <Fragment>
      <main className="page_content about-page ">
        <PageTitle pageTitle={"Search Engine Optimization Specialist"} />
        <div className="pt-175 pb-80 ">
            <div className="container">
                <h4 className="mb-4">Job Description</h4>
                <p>At Apeitsolutions, we are committed to delivering high-quality travel experiences to our customers worldwide. With our rapidly growing online presence, we are looking for an experienced SEO Specialist to enhance our digital footprint and drive organic traffic to our platforms.</p>
                
                <h4 className="mb-4">Key Responsibilities:</h4>
                <ul>
                    <li>Develop and implement effective SEO strategies to improve organic search rankings.</li>
                    <li>Conduct keyword research and use SEO tools to monitor performance.</li>
                    <li>Optimise website content, landing pages, and blog posts.</li>
                    <li>Collaborate with content writers and marketing teams to create high-performing, SEO-friendly content.</li>
                    <li>Analyse website traffic and user engagement metrics using tools like Google Analytics.</li>
                    <li>Stay updated on the latest trends and best practices in SEO and digital marketing.</li>
                </ul>

                <h4 className="mb-4">Qualifications:</h4>
                <ul>
                    <li>Proven experience as an SEO Specialist or similar role.</li>
                    <li>Proficiency with SEO tools such as Google Analytics, Ahrefs, SEMrush, or Moz.</li>
                    <li>Strong understanding of search engine algorithms and ranking methods.</li>
                    <li>Familiarity with WordPress or other CMS platforms.</li>
                    <li>Excellent analytical and problem-solving skills.</li>
                    <li>Knowledge of HTML/CSS is a plus.</li>
                </ul>

                <h4 className="mb-4">What We Offer:</h4>
                <ul>
                    <li>Competitive salary and benefits package.</li>
                    <li>Opportunity to work with a passionate and collaborative team.</li>
                    <li>Professional growth and learning opportunities.</li>
                </ul>

                <p className="mt-5">Send your updated CV and a short introduction to: <strong>hr@apeitsolutions.com</strong></p>
                {/* <Link to='/seo-detail' class="btn btn-primary mt-5">
                <span class="btn_label" data-text="Apply Now"> Apply Now </span>
                <span class="btn_icon">
                    <i class="fa-solid fa-arrow-up-right"></i>
                </span>
            </Link> */}
            </div>
        </div>
      </main>
      <Scrollbar />
    </Fragment>
  );
};

export default SeoDetailPage;
